/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
import { ITheme } from '@chakra-ui/core'
export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  let timeout: ReturnType<typeof setTimeout> | null = null

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const debounced = (...args: Parameters<F>) => {
    if (timeout !== null) {
      clearTimeout(timeout)
      timeout = null
    }
    timeout = setTimeout(() => func(...args), waitFor)
  }

  return debounced as (...args: Parameters<F>) => ReturnType<F>
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export const parseTheme = (themeConfig: any, defaultTheme: ITheme): ITheme => {
  try {
    const { metadata } = themeConfig

    const replaceArray = [
      { value: '_2xl', replace: '2xl' },
      { value: '_3xl', replace: '3xl' },
      { value: '_4xl', replace: '4xl' },
      { value: '_5xl', replace: '5xl' },
      { value: '_6xl', replace: '6xl' },
      { value: '_50', replace: 50 },
      { value: '_100', replace: 100 },
      { value: '_200', replace: 200 },
      { value: '_300', replace: 300 },
      { value: '_400', replace: 400 },
      { value: '_500', replace: 500 },
      { value: '_600', replace: 600 },
      { value: '_700', replace: 700 },
      { value: '_800', replace: 800 },
      { value: '_900', replace: 900 },
      { value: 'chevronLeft', replace: 'chevron-left' },
    ]
    const iconKeys = ['chevronLeft', 'search', 'settings', 'plus', 'minus']

    const replace = (obj: any) => {
      return Object.keys(obj).reduce((acc, key) => {
        if (typeof obj[key] === 'object') {
          const nested = replace(obj[key])
          if (typeof nested === 'object' && Object.keys(nested).length !== 0) acc[key] = nested
          return acc
        }
        const found = replaceArray.find((element) => element.value === key)
        if (iconKeys.includes(key)) {
          try {
            acc[key] = JSON.parse(obj[key])
          } catch (e) {
            return acc
          }
        }
        if (found) {
          acc[found.replace] = obj[key]
        } else {
          acc[key] = obj[key]
        }
        return acc
      }, {} as any) as any
    }

    const customTheme = replace(metadata)
    Object.keys(defaultTheme).forEach((key) => {
      if (customTheme[key]) {
        customTheme[key] = { ...defaultTheme[key as keyof ITheme], ...customTheme[key] }
      } else {
        customTheme[key] = defaultTheme[key as keyof ITheme]
      }
    })
    return customTheme
  } catch (e) {
    return defaultTheme
  }
}
